import { h } from 'preact'
import { useRef, useEffect } from 'preact/hooks'
import translate from '@core/hooks/useResource'

const SearchInput = ({ onKeyUp, searchTerm, loading = true, hasResults }) => {
	const inputRef = useRef(null)

	useEffect(() => {
		setTimeout(() => {
			const searchIcon = document.querySelector('[data-drawer-toggle="search"]')

			if (searchIcon) {
				searchIcon.addEventListener('click', () => {
					const el = document.getElementById('es-quicksearch-input')
					el.focus()
				})
			}
		}, 100)
	}, [])

	return (
		<section className={`quicksearch ${hasResults ? '--has-results' : ''}`}>
			<input
				autoComplete="off"
				label="Term"
				id="es-quicksearch-input"
				placeholder={translate('search.searchTerm')}
				onKeyUp={e => onKeyUp(e)}
				type="text"
				ref={inputRef}
			/>
			<div className="icon-wrapper">
				{loading && (
					<svg
						className="is-rotating quicksearch-icon"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill="#222"
							d="M16.0518 5.0285C15.7169 5.46765 15.8013 6.09515 16.2405 6.43007C17.9675 7.74714 19 9.78703 19 12C19 15.4973 16.4352 18.3956 13.084 18.9166L13.7929 18.2071C14.1834 17.8166 14.1834 17.1834 13.7929 16.7929C13.4024 16.4024 12.7692 16.4024 12.3787 16.7929L9.87868 19.2929C9.48816 19.6834 9.48816 20.3166 9.87868 20.7071L12.3787 23.2071C12.7692 23.5976 13.4024 23.5976 13.7929 23.2071C14.1834 22.8166 14.1834 22.1834 13.7929 21.7929L12.9497 20.9505C17.4739 20.476 21 16.6498 21 12C21 9.15644 19.6712 6.53122 17.4533 4.83978C17.0142 4.50486 16.3867 4.58936 16.0518 5.0285ZM14.1213 3.29289L11.6213 0.792893C11.2308 0.402369 10.5976 0.402369 10.2071 0.792893C9.84662 1.15338 9.81889 1.72061 10.1239 2.1129L10.2071 2.20711L11.0503 3.04951C6.52615 3.52399 3 7.35021 3 12C3 14.7198 4.21515 17.2432 6.2716 18.9419C6.6974 19.2936 7.32771 19.2335 7.67943 18.8077C8.03116 18.3819 7.97111 17.7516 7.54531 17.3999C5.94404 16.0772 5 14.1168 5 12C5 8.50269 7.56475 5.60441 10.916 5.08343L10.2071 5.79289C9.81658 6.18342 9.81658 6.81658 10.2071 7.20711C10.5676 7.56759 11.1348 7.59532 11.5271 7.2903L11.6213 7.20711L14.1213 4.70711C14.4818 4.34662 14.5095 3.77939 14.2045 3.3871L14.1213 3.29289Z"
						/>
					</svg>
				)}
				<svg
					className="quicksearch-icon"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.5 2C16.7467 2 21 6.25329 21 11.5C21 13.5819 20.3303 15.5074 19.1946 17.0729L25.5607 23.4393C26.1464 24.0251 26.1464 24.9749 25.5607 25.5607C25.0115 26.1098 24.1424 26.1442 23.5533 25.6636L23.4393 25.5607L17.0729 19.1946C15.5074 20.3303 13.5819 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 6.25329 6.25329 2 11.5 2ZM11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5Z"
						fill="#212121"
					/>
				</svg>
			</div>
		</section>
	)
}

export default SearchInput
